/* ==========================================================================
   Kleos — Side-cart (carrito lateral)
   AJAX Cart API (/cart/*.js) + rebuild del DOM dinámico leyendo /cart.js.
   Sin dependencias. Se auto-inicializa una sola vez.

   CONTRATO con el resto del tema:
     · Botones con [data-cart-open] (header) y enlaces a /cart abren el drawer.
     · Formularios action*=/cart/add se interceptan por AJAX y abren el drawer.
     · Eventos que ESCUCHA: 'cart:open', 'cart-drawer:open', 'cart:refresh',
       'cart:added' y 'cart:updated' (de otros scripts, p.ej. quick-add).
     · Evento que EMITE en cada cambio: 'cart:updated'
       detail: { cart, source: 'iurop-cart-drawer' }.
     · API pública: window.iuropCartDrawer { open, close, refresh, addItem }.
     · Burbuja del header: [data-cart-count] (texto + atributo hidden si 0).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__iuropCartInit) return;
  window.__iuropCartInit = true;

  var SOURCE = 'iurop-cart-drawer';
  var root, panel, overlay;
  var moneyFormat = '${{amount_with_comma_separator}}';
  /* Valores de respaldo por si el raíz aún no está en el DOM: los REALES
     llegan de los data-* que emite iurop-cart-drawer.liquid desde los ajustes
     del tema (ver readAttrs). El umbral debe coincidir con el de Shopify › Envíos. */
  var shipThreshold = 17000000; // centavos — envío gratis
  var txtShipFree = '¡Conseguiste el <strong>envío gratis</strong>!';
  var txtShipAway = '¡Gastá <strong>[importe]</strong> más y obtené envío gratis!';
  var reserveSeconds = 600;     // 10:00 de reserva
  var timerId = null;
  var lastFocused = null;

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function resizeImg(url, w) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var match = f.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return f.replace(placeholder, value);
  }

  /* ---------- abrir / cerrar + focus-trap ---------- */
  function focusables() {
    if (!panel) return [];
    return $all('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function trapFocus(e) {
    if (e.key !== 'Tab' || !isOpen()) return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function open() {
    if (!root || isOpen()) { if (root) refresh(); return; }
    lastFocused = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; // reflow para que corra la transición
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('iurop-cd-locked');
    startTimer();
    syncUpsellArrows();
    refresh();
    var closeBtn = $('[data-cart-close]', panel);
    if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('iurop-cd-locked');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    if (lastFocused && document.contains(lastFocused)) {
      try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
    }
    lastFocused = null;
  }
  function isOpen() { return !!root && root.classList.contains('is-open'); }

  /* ---------- AJAX Cart API ---------- */
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function getCart() {
    return fetch(routeRoot() + 'cart.js', {
      headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }
  function addItem(id, quantity, props) {
    var body = { id: id, quantity: quantity || 1 };
    if (props) body.properties = props;
    return postJSON(routeRoot() + 'cart/add.js', body);
  }
  function changeItem(key, quantity) {
    return postJSON(routeRoot() + 'cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function (err) { showError(err); return refresh(); });
  }
  function refresh() { return getCart().then(function (c) { renderCart(c); return c; }); }

  /* ---------- aviso de error (422 de la Cart API) ---------- */
  var errorTimer = null;
  function showError(err) {
    if (!root) return;
    var msg = err && (err.description || err.message);
    if (typeof msg !== 'string' || !msg) msg = 'No se pudo completar la acción. Intentalo de nuevo.';
    var body = $('[data-cd-body]', root);
    if (!body) return;
    var node = $('[data-cd-error]', root);
    if (!node) {
      node = document.createElement('p');
      node.className = 'iurop-cd__error';
      node.setAttribute('data-cd-error', '');
      node.setAttribute('role', 'alert');
      body.insertBefore(node, body.firstChild);
    }
    node.textContent = msg;
    node.hidden = false;
    if (errorTimer) clearTimeout(errorTimer);
    errorTimer = setTimeout(function () { node.hidden = true; }, 6000);
  }

  /* ---------- render ---------- */
  function itemHTML(item) {
    var img = item.image
      ? '<img class="iurop-cd__item-img" src="' + esc(resizeImg(item.image, 170)) + '" alt="' + esc(item.product_title || item.title) + '" width="85" height="96" loading="lazy">'
      : '<span class="iurop-cd__item-img iurop-cd__img-ph"></span>';
    var variant = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variant = '<p class="iurop-cd__item-variant">' + esc(item.variant_title) + '</p>';
    }
    var compare = '';
    if (item.original_line_price > item.final_line_price) {
      compare = '<span class="iurop-cd__item-compare">' + formatMoney(item.original_line_price) + '</span>';
    }
    var off = '';
    if (item.original_price > item.final_price) {
      var pct = Math.round((1 - item.final_price / item.original_price) * 100);
      if (pct > 0) off = '<span class="iurop-cd__item-off">' + pct + '% OFF</span>';
    }
    return '' +
      '<li class="iurop-cd__item" data-cd-item data-key="' + esc(item.key) + '">' +
        '<a class="iurop-cd__item-media" href="' + esc(item.url) + '" tabindex="-1">' + img + '</a>' +
        '<div class="iurop-cd__item-main">' +
          '<div class="iurop-cd__item-top">' +
            '<a class="iurop-cd__item-title" href="' + esc(item.url) + '">' + esc(item.product_title || item.title) + '</a>' +
            variant +
            '<div class="iurop-cd__item-prices">' +
              compare +
              '<span class="iurop-cd__item-price">' + formatMoney(item.final_line_price) + '</span>' +
              off +
            '</div>' +
          '</div>' +
          '<div class="iurop-cd__item-actions">' +
            '<div class="iurop-cd__stepper" data-cd-stepper>' +
              '<button type="button" class="iurop-cd__step" data-cd-minus aria-label="Quitar una unidad">&minus;</button>' +
              '<span class="iurop-cd__step-val" data-cd-qty>' + item.quantity + '</span>' +
              '<button type="button" class="iurop-cd__step" data-cd-plus aria-label="Agregar una unidad">+</button>' +
            '</div>' +
            '<button type="button" class="iurop-cd__item-remove" data-cd-remove>Eliminar</button>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function renderShipbar(cart) {
    if (shipThreshold <= 0) return;
    var textEl = $('[data-cd-ship-text]', root);
    var fillEl = $('[data-cd-ship-fill]', root);
    if (fillEl) {
      var pct = Math.min(100, (cart.total_price / shipThreshold) * 100);
      fillEl.style.width = pct.toFixed(2) + '%';
    }
    if (textEl) {
      /* Los textos salen de Ajustes del tema y llegan por data-* del raíz. Antes
         estaban escritos aquí, así que el primer refresh AJAX pisaba lo que el
         comerciante hubiera puesto en el editor: la barra "no era dinámica". */
      if (cart.total_price >= shipThreshold) {
        textEl.innerHTML = txtShipFree;
      } else {
        var falta = formatMoney(shipThreshold - cart.total_price);
        textEl.innerHTML = txtShipAway.split('[importe]').join(falta);
      }
    }
  }

  function renderCart(cart, silent) {
    if (!root || !cart || !cart.items) return;
    var empty = cart.item_count === 0;
    root.classList.toggle('is-empty', empty);

    // contadores: drawer + burbuja del header
    $all('[data-cd-count]', root).forEach(function (el) { el.textContent = cart.item_count; });
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });

    // líneas de producto
    var list = $('[data-cd-items]', root);
    if (list) list.innerHTML = cart.items.map(itemHTML).join('');

    // barra de envío gratis
    renderShipbar(cart);

    // subtotal (tachado + final)
    var compareEl = $('[data-cd-subtotal-compare]', root);
    if (compareEl) {
      if (cart.original_total_price > cart.total_price) {
        compareEl.textContent = formatMoney(cart.original_total_price);
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }
    $all('[data-cd-subtotal]', root).forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

    // cuenta atrás de reserva
    if (empty) stopTimer(); else if (isOpen()) startTimer();

    // upsells: ocultar los que ya están en el carrito (el render es
    // client-side desde /cart.js, sin Section Rendering — el filtro
    // Liquid solo aplica a la carga inicial)
    var inCart = {};
    cart.items.forEach(function (it) { inCart[String(it.product_id)] = true; });
    var upsellCards = $all('[data-cd-upsell-card]', root);
    var visibleUpsells = 0;
    upsellCards.forEach(function (card) {
      if (inCart[card.getAttribute('data-product-id')]) {
        card.setAttribute('hidden', '');
      } else {
        card.removeAttribute('hidden');
        visibleUpsells++;
      }
    });
    var upsellBlock = $('.iurop-cd__upsell', root);
    if (upsellBlock && upsellCards.length) {
      if (visibleUpsells === 0) upsellBlock.setAttribute('hidden', '');
      else upsellBlock.removeAttribute('hidden');
    }

    // indicador de scroll + flechas de upsells
    syncUpsellScroll();
    syncUpsellArrows();

    // aviso global
    if (!silent) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: SOURCE } }));
    }
  }

  /* ---------- reserva (cuenta atrás) ---------- */
  function startTimer() {
    var el = $('[data-cd-timer]', root);
    if (!el || timerId) return;
    var end = parseInt(sessionStorage.getItem('iuropCartReserveEnd') || '0', 10);
    var now = Date.now();
    if (!end || end < now) { end = now + reserveSeconds * 1000; sessionStorage.setItem('iuropCartReserveEnd', String(end)); }
    function tick() {
      var remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) {
        end = Date.now() + reserveSeconds * 1000;
        sessionStorage.setItem('iuropCartReserveEnd', String(end));
        remaining = reserveSeconds;
      }
      var m = Math.floor(remaining / 60), s = remaining % 60;
      el.textContent = m + ':' + (s < 10 ? '0' + s : s);
    }
    tick();
    timerId = setInterval(tick, 1000);
  }
  function stopTimer() { if (timerId) { clearInterval(timerId); timerId = null; } }

  /* ---------- indicador de scroll de upsells ---------- */
  function syncUpsellScroll() {
    var row = $('[data-cd-upsell-row]', root);
    var thumb = $('[data-cd-upsell-thumb]', root);
    if (!row || !thumb) return;
    var total = row.scrollWidth;
    var visible = row.clientWidth;
    if (total <= visible) { thumb.style.width = '100%'; thumb.style.transform = 'none'; return; }
    var w = (visible / total) * 100;
    var x = (row.scrollLeft / total) * 100;
    thumb.style.width = w.toFixed(2) + '%';
    thumb.style.transform = 'translateX(' + ((x / w) * 100).toFixed(2) + '%)';
  }

  /* ---------- flechas del carrusel de upsells (desktop) ---------- */
  function syncUpsellArrows() {
    var row = $('[data-cd-upsell-row]', root);
    var prev = $('[data-cd-up-prev]', root);
    var next = $('[data-cd-up-next]', root);
    if (!row || !prev || !next) return;
    var max = row.scrollWidth - row.clientWidth;
    var x = row.scrollLeft;
    prev.classList.toggle('is-hidden', x <= 2);
    next.classList.toggle('is-hidden', max <= 2 || x >= max - 2);
  }
  function scrollUpsell(dir) {
    var row = $('[data-cd-upsell-row]', root);
    if (!row) return;
    var card = row.querySelector('.iurop-cd__upsell-card:not([hidden])');
    var gap = parseFloat(getComputedStyle(row).columnGap) || 12;
    var step = card ? card.getBoundingClientRect().width + gap : row.clientWidth;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollBy({ left: dir * step, behavior: (reduced || document.hidden) ? 'auto' : 'smooth' });
  }

  /* ---------- delegación de eventos dentro del drawer ---------- */
  function onRootClick(e) {
    var t = e.target;

    var closeNav = t.closest('[data-cart-close-nav]');
    if (closeNav) { close(); return; } // deja navegar el enlace

    if (t.closest('[data-cart-close]') || t === overlay) { e.preventDefault(); close(); return; }

    var minus = t.closest('[data-cd-minus]');
    var plus = t.closest('[data-cd-plus]');
    var remove = t.closest('[data-cd-remove]');
    if (minus || plus || remove) {
      var li = t.closest('[data-cd-item]');
      if (!li) return;
      var key = li.getAttribute('data-key');
      var qtyEl = $('[data-cd-qty]', li);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      li.classList.add('is-loading');
      if (remove) changeItem(key, 0);
      else if (minus) changeItem(key, Math.max(0, qty - 1));
      else changeItem(key, qty + 1);
      return;
    }

    var upPrev = t.closest('[data-cd-up-prev]');
    var upNext = t.closest('[data-cd-up-next]');
    if (upPrev || upNext) { scrollUpsell(upPrev ? -1 : 1); return; }

    var add = t.closest('[data-cd-add]');
    if (add) {
      var vid = add.getAttribute('data-cd-add');
      if (!vid) return;
      add.classList.add('is-loading'); add.disabled = true;
      addItem(vid, 1)
        .then(function () { return refresh(); })
        .then(function () { add.classList.remove('is-loading'); add.disabled = false; })
        .catch(function (err) {
          add.classList.remove('is-loading'); add.disabled = false;
          showError(err);
        });
      return;
    }
  }

  /* ---------- disparadores globales de apertura ---------- */
  function isCartLink(a) {
    if (!a || !a.getAttribute) return false;
    if (a.hasAttribute('data-no-drawer')) return false;
    var href = a.getAttribute('href') || '';
    return /(^|\/)cart\/?($|\?|#)/.test(href.split('?')[0]);
  }
  function onDocClick(e) {
    var toggle = e.target.closest('[data-cart-open],[data-cart-drawer-toggle],[data-cart-toggle],.js-cart-toggle,#cart-icon-bubble');
    if (toggle) { e.preventDefault(); open(); return; }
    var link = e.target.closest('a');
    if (link && isCartLink(link)) { e.preventDefault(); open(); }
  }
  function onDocSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var conSubida = typeof form.__iuropHandleCartError === 'function';
    if (btn && conSubida && btn.disabled) return;   /* doble toque mientras sube */
    if (btn) btn.classList.add('is-loading');
    var cuentaAntes = null;
    if (btn && conSubida) btn.disabled = true;
    function fin() {
      if (btn) { btn.classList.remove('is-loading'); if (conSubida) btn.disabled = false; }
    }
    function montar() {
      var fd = new FormData(form);
      if (typeof form.__iuropAppendFileProperties === 'function') {
        form.__iuropAppendFileProperties(fd);
      }
      return fd;
    }
    function enviar(intento) {
      return fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        body: montar(),
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      }).catch(function (err) {
        /* Corte de red a mitad de subida (datos móviles): las fotos ya están
           copiadas en memoria, así que un reintento es seguro. */
        if (conSubida && intento < 2) {
          return new Promise(function (ok) { setTimeout(ok, 1500); })
            .then(function () { return getCart().catch(function () { return null; }); })
            .then(function (c) {
              /* La 1.ª petición llegó y solo se perdió la respuesta: el carrito
                 ya creció → no reenviar (evita la línea duplicada). */
              if (c && cuentaAntes !== null && c.item_count > cuentaAntes) {
                return { ok: true, status: 200, text: function () { return Promise.resolve('{}'); } };
              }
              return enviar(intento + 1);
            });
        }
        throw err;
      });
    }
    /* add.js responde text/javascript: leer texto y parsear sin exigir JSON
       (una página HTML de 429/5xx no debe confundirse con un fallo de red). */
    function leer(r) {
      return r.text().then(function (t) {
        var data = null;
        try { data = JSON.parse(t); } catch (e) {}
        return { ok: r.ok, status: r.status, data: data };
      });
    }
    Promise.resolve()
      .then(function () {
        return typeof form.__iuropBeforeSubmit === 'function' ? form.__iuropBeforeSubmit() : null;
      })
      .then(function () {
        if (!conSubida) return null;
        return getCart().then(function (c) { if (c && typeof c.item_count === 'number') cuentaAntes = c.item_count; }, function () {});
      })
      .then(function () { return enviar(1); })
      .then(leer)
      .then(function (res) {
        fin();
        if (!res.ok) {
          // 422: agotado / límite de stock — mostrar el aviso de Shopify,
          // no abrir como si el producto se hubiera añadido
          var data = res.data || {};
          if (conSubida) {
            var e = new Error('http ' + res.status);
            e.__iuropMsg = res.status === 429
              ? 'Hay muchas solicitudes ahora mismo. Esperá unos segundos e intentá de nuevo.'
              : (data.description || data.message || null);
            form.__iuropHandleCartError(e);
            return;
          }
          showError(res.data);
        }
        open();
      })
      .catch(function (err) {
        fin();
        /* Un segundo submit nativo no puede recuperar un fichero que el
           navegador ya no puede leer y termina en /cart/add con una pagina de
           error. En formularios con subida, conservar la pagina y permitir
           que el componente muestre un mensaje accionable. */
        if (conSubida) {
          form.__iuropHandleCartError(err);
          return;
        }
        form.submit();
      });
  }

  /* ---------- init ---------- */
  function init() {
    root = document.getElementById('CartDrawer');
    if (!root) return;
    panel = $('.iurop-cd__panel', root);
    overlay = $('.iurop-cd__overlay', root);
    moneyFormat = root.getAttribute('data-money-format') || moneyFormat;
    shipThreshold = parseInt(root.getAttribute('data-ship-threshold') || shipThreshold, 10);
    reserveSeconds = parseInt(root.getAttribute('data-reserve-seconds') || reserveSeconds, 10);
    txtShipFree = root.getAttribute('data-txt-ship-free') || txtShipFree;
    txtShipAway = root.getAttribute('data-txt-ship-away') || txtShipAway;

    root.addEventListener('click', onRootClick);
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('submit', onDocSubmit, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
      else trapFocus(e);
    });

    var upsellRow = $('[data-cd-upsell-row]', root);
    if (upsellRow) {
      upsellRow.addEventListener('scroll', function () {
        syncUpsellScroll();
        syncUpsellArrows();
      }, { passive: true });
    }

    // eventos públicos para otros scripts del tema
    document.addEventListener('cart:open', open);
    document.addEventListener('cart-drawer:open', open);
    document.addEventListener('cart:refresh', function () { refresh(); });
    document.addEventListener('cart:added', function () { refresh(); open(); });
    document.addEventListener('cart:updated', function (e) {
      // refresco pedido por otros scripts (quick-add, PDP…): sin re-emitir
      if (e.detail && e.detail.source === SOURCE) return;
      if (e.detail && e.detail.cart) renderCart(e.detail.cart, true);
      else getCart().then(function (c) { renderCart(c, true); });
    });
  }

  // API pública (contrato con iurop-product-card.js y el resto del tema)
  var api = {
    open: open,
    close: close,
    refresh: refresh,
    addItem: function (id, qty, props) {
      return addItem(id, qty, props).then(function () { return refresh(); }).then(function (c) { open(); return c; });
    }
  };
  window.iuropCartDrawer = api;
  window.iuropCart = api; // alias legado

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
